import * as $ from "jquery";
import { initPodcastFilters } from "./podcast-archive";
import { initGuideFilters } from "./guide-archive";
import apiFetch from "@wordpress/api-fetch";

$(function () {
  var $body = $("body");
  var $inclusion_close = $(".inclusion-sidebar_close");
  var $inclusion_home_link = $(".inclusion-module_link");
  var $inclusion_footer_close = $(".inclusion-footer-backtofed a");
  var $inclusion_menu_toggle = $(".inclusion_toggle-menu");
  var $inclusion_menu = $(".inclusion-nav");
  var $inclusion_wrapper = $(".inclusion-wrapper");
  var $inclusion_page = $(".inclusion-page");
  var sourceURL = {};
  var inclusionURLLoaded = "";
  if (!$body.hasClass("is_inclusion_page")) {
    sourceURL = window.location.href;
  }
  var previousURL = document.location.href;

  $(window).on("popstate", function (e) {
    var link = document.location.href;
    if (link === inclusionData.homeURL) {
      if (previousURL && Number(previousURL.search("inclusion")) !== -1) {
        $inclusion_close.attr("href", previousURL);
        $inclusion_footer_close.attr("href", previousURL);
      }
      inclusion_close(false);
    }
    if (
      Number(link.search("inclusion")) !== -1 &&
      previousURL.replace(/#.*/, "") !== link.replace(/#.*/, "")
    ) {
      inclusion_open();
      load_inclusion_page(link, false);
    }
  });

  $inclusion_page.on(
    "click",
    "a:not([href$='.pdf']):not(.aside-navigation-link)",
    function (e) {
      const url = new URL(e.target.href);
      const thisUrl = new URL(document.location.href);
      if (e.target.href && e.target.href !== inclusionData.homeURL) {
        load_inclusion_page(e.target.href);
        e.preventDefault();
        return false;
      } else if (!url.hostname !== thisUrl) {
        inclusion_close();
        e.preventDefault();
        return false;
      }
    }
  );

  $inclusion_page.on(
    "click",
    ".inclusion-select-container button",
    function (e) {
      $(".inclusion-select-container").toggleClass("is-open");
    }
  );

  $inclusion_page.on("click", ".inclusion-select-container a", function (e) {
    $(".inclusion-select-container").removeClass("is-open");
    const url = new URL(e.target.href);
    const thisUrl = new URL(document.location.href);
    if (e.target.href && e.target.href !== inclusionData.homeURL) {
      load_inclusion_page(e.target.href);
      e.preventDefault();
      return false;
    } else if (!url.hostname !== thisUrl) {
      inclusion_close();
      e.preventDefault();
      return false;
    }
  });

  $inclusion_menu.on("click", "a", function (e) {
    const url = new URL(e.target.href);
    const thisUrl = new URL(document.location.href);
    if (e.target.href && Number(e.target.href.search("inclusion")) !== -1) {
      inclusion_menu_close();
      load_inclusion_page(e.target.href);
      e.preventDefault();
      return false;
    } else if (url.hostname === thisUrl.hostname) {
      inclusion_menu_close();
      inclusion_close();
      e.preventDefault();
      return false;
    }
  });

  $inclusion_footer_close.on("click", function (e) {
    e.preventDefault();
    inclusion_toggle();
  });
  $inclusion_close.on("click", function (e) {
    e.preventDefault();
    inclusion_toggle();
  });
  $inclusion_home_link.on("click", function (e) {
    e.preventDefault();
    inclusion_toggle();
  });

  $inclusion_menu_toggle.on("click", function () {
    inclusion_menu_toggle();
  });

  function inclusion_menu_toggle() {
    if ($body.hasClass("is_inclusion_menu_open")) {
      inclusion_menu_close();
      $inclusion_menu_toggle.removeClass("is-active");
    } else {
      inclusion_menu_open();
    }
  }

  function inclusion_menu_close() {
    $inclusion_menu_toggle.removeClass("is-active");
    $inclusion_menu.fadeOut(500, function () {
      $body.removeClass("is_inclusion_menu_open");
    });
  }

  function inclusion_menu_open() {
    $inclusion_menu_toggle.addClass("is-active");
    $inclusion_menu
      .css("display", "flex")
      .hide()
      .fadeIn(500, function () {
        $inclusion_wrapper.scrollTop(0);
        $body.addClass("is_inclusion_menu_open");
      });
  }

  function inclusion_toggle() {
    if ($body.hasClass("is_inclusion_open")) {
      inclusion_close();
    } else {
      var link = $inclusion_close.attr("href");
      $body.addClass("inclusion-from-closed");
      inclusion_open();
      load_inclusion_page(link);
    }
  }

  function inclusion_close(updateHistory = true) {
    $body
      .addClass("inclusion_will_close")
      .removeClass("is_inclusion_open")
      .removeClass("has_inclusion_loaded");
    const href = window.location.href;
    $inclusion_wrapper.scrollTop(0);
    inclusion_menu_close();
    $inclusion_close.find("span").text("Découvrez la websérie");
    if (href !== inclusionData.homeURL) {
      $inclusion_close.attr("href", href);
      $inclusion_footer_close.attr("href", href);
    }
    setTimeout(() => {
      $body.removeClass("inclusion_will_close");
      // Durée de l’anim : 1800ms. 2000 pour être large.
    }, 2000);

    if ($body.hasClass("is_page_empty")) {
      load_homepage();
    } else if (sourceURL) {
      const url = new URL(sourceURL);
      if (updateHistory) {
        window.history.pushState({}, "", url);
      }
      previousURL = url.href;
    }
  }

  function inclusion_open() {
    $body.addClass("is_inclusion_open").addClass("inclusion_will_open");
    setTimeout(() => {
      $body.removeClass("inclusion_will_open");
    }, 4000);
    // setTimeout(() => {
    //   $inclusion_close.find("span").text("Retour à la Fédération Syntec");
    // }, 600);
    $inclusion_close.attr(
      "href",
      sourceURL ? sourceURL : inclusionData.homeURL
    );
    if (!$body.hasClass("is_inclusion_page")) {
      $body.addClass("is_inclusion_page");
    }
  }

  function load_homepage(updateHistory = true) {
    $body.addClass("is_page_loading");
    apiFetch({
      path: `syntec/v1/inclusion?url=${inclusionData.homeURL}`,
    }).then((data) => {
      $body.removeClass("is_page_loading");
      const url = new URL(inclusionData.homeURL);
      if (updateHistory) {
        window.history.pushState({}, "", url);
      }
      previousURL = url.href;
      if (data.content) {
        $body.addClass("home").removeClass("is_page_empty");
        $('main[role="main"]').append(data.content);
        $('main[role="main"]').trigger("homeLoaded");
      }
      if (data?.body_class) {
        const body_class =
          $("body")
            .attr("class")
            .split(" ")
            .filter(function (className) {
              return ["admin-bar", "customize-support"].includes(className);
            })
            .join(" ") +
          " " +
          data.body_class;
        $body.attr("class", body_class);
      }
      if (data.yoast?.json?.title) {
        document.title = data.yoast.json.title;
      }
    });
  }

  function load_inclusion_page(link, updateHistory = true) {
    if (inclusionURLLoaded !== link) {
      $body.addClass("is-inclusion-page-loading");
      if (!$body.hasClass("inclusion-from-closed")) {
        $inclusion_page.fadeOut(800);
      }
      apiFetch({
        path: `syntec/v1/inclusion?url=${link}`,
      }).then((data) => {
        $body.removeClass("is_inclusion_page_loading");
        $body.addClass("has_inclusion_loaded");
        const url = new URL(link);
        if (updateHistory) {
          window.history.pushState({}, "", url);
        }
        previousURL = url.href;
        inclusionURLLoaded = link;
        if (data.content) {
          if (data.theme) {
            if (data.theme === "light") {
              $inclusion_wrapper
                .removeClass("inclusion-theme-dark")
                .addClass("inclusion-theme-light");
            }
            if (data.theme === "dark") {
              $inclusion_wrapper
                .removeClass("inclusion-theme-light")
                .addClass("inclusion-theme-dark");
            }
          }
          $inclusion_page.html(data.content);
          if (!$body.hasClass("inclusion-from-closed")) {
            $inclusion_page.fadeIn(800);
          }
          $body.removeClass("inclusion-from-closed");
          $inclusion_wrapper.scrollTop(0);
          if (emergence) {
            emergence.engage();
          }
          if ($("#podcast-filters").length > 0) {
            initPodcastFilters();
          }
          if ($("#guide-filters").length > 0) {
            initGuideFilters();
          }
        }
        if (data?.title) {
          document.title = data.title;
        }
        if (data?.body_class) {
          const body_class =
            $("body")
              .attr("class")
              .split(" ")
              .filter(function (className) {
                return ["admin-bar", "customize-support"].includes(className);
              })
              .join(" ") +
            " " +
            data.body_class;
          $body.attr("class", body_class);
        }

        $(window).trigger("load.inclusionPage");

        if (data.edit_text && data.id) {
          $("#wpadminbar")
            .find('a[href*="&post="],a[href*="?post="]')
            .each(function (index, el) {
              $(el).attr(
                "href",
                $(el)
                  .attr("href")
                  .replace(/(&|\?)(post=)([0-9]+)/, "$1$2" + data.id)
              );
              $(el).text(data.edit_text);
            });
        }
        setTimeout(() => {
          $body.removeClass("is-inclusion-page-loading");
        }, 1000);
      });
    } else {
      $body.removeClass("is_inclusion_page_loading");
      $body.removeClass("inclusion-from-closed");
      setTimeout(() => {
        $body.removeClass("is-inclusion-page-loading");
      }, 1000);
      const url = new URL(link);
      if (updateHistory) {
        window.history.pushState({}, "", url);
      }
      previousURL = url.href;
    }
  }

  if ($("#podcast-filters").length > 0) {
    initPodcastFilters();
  }

  if ($("#guide-filters").length > 0) {
    initGuideFilters();
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $nav = $(".inclusion-nav");
  var $nav_items = $nav.find(".menu-item-has-children");
  var $nav_links = $nav.find(".menu-item-has-children > a");
  $nav_links.each(function (idx, el) {
    $(el).on("click", trigger_nav_link);
  });

  function trigger_nav_link(event) {
    var $this = $(this);
    var $link_item = $this.closest(".menu-item-has-children");
    var $sub_menu = $link_item.find(".sub-menu");
    if (!$sub_menu.length) {
      return;
    }
    event.preventDefault();
    if ($link_item.hasClass("is-open")) {
      $link_item.removeClass("is-open");
    } else {
      $nav_items.removeClass("is-open");
      $link_item.addClass("is-open");
    }
    return false;
  }
});
